import type { ValueOf } from "@vy/utils";

export const PRODUCT_OPTION_TYPE = Object.freeze({
    CATALOG: 'catalog',
    ADD_PRODUCT: 'add-product',
});

export type ProductOptionType = ValueOf<typeof PRODUCT_OPTION_TYPE>;

export type ProductOption = {
    label: string;
    value: string;
    type: ProductOptionType;
};